/* eslint-disable max-classes-per-file */
import {
  MainTableFilterModel,
  PrintReportFilterModel,
} from 'src/app/shared/models/main-table-filter.model';
import { NonConformanceStatus } from '../enums/non-conformance-status.enum';
import { IDelegateNonConformanceRequest } from '../models/delegate-non-conformance-request';
import { IdComment } from '../models/id-comment.model';
import { INonConformanceRequest } from '../models/non-conformance.model';
import { IPrintNonConformanceModel } from '../models/print-non-conformance.model';
import { ISignNonConformanceModel } from '../models/sign-non-conformance.model';
import { ISubtaskRequest } from '../models/subtask.model';
import { NonConformanceActionType } from '../enums/non-conformance-action-type.enum';

export class LoadWindForces {
  static readonly type = '[Non Conformance] Load Wind Forces';
  constructor() {}
}

export class LoadWindDirections {
  static readonly type = '[Non Conformance] Load Wind Directions';
  constructor() {}
}

export class LoadNonConformances {
  static readonly type = '[Non Conformance] Load Non Conformances';
  constructor(
    public state?: NonConformanceStatus,
    public filter?: MainTableFilterModel,
    public allDeps?: boolean,
    public relatedNonConformancesOnly?: boolean
  ) {}
}

export class LoadNonConformancesForIO {
  static readonly type = '[Non Conformance] Load Non Conformances for IO';
  constructor() {}
}

export class CreateNonConformance {
  static readonly type = '[Non Conformance] Create Non Conformance';
  constructor(public nonConformance: INonConformanceRequest) {}
}

export class UpdateNonConformance {
  static readonly type = '[Non Conformance] Update Non Conformance';
  constructor(public nonConformance: INonConformanceRequest) {}
}

export class GetNonConformanceById {
  static readonly type = '[Non Conformance] Get Non Conformance By Id';
  constructor(public id: string) {}
}

export class DeleteNonConformance {
  static readonly type = '[Non Conformance] Delete Non Conformance';
  constructor(public idComment: IdComment) {}
}

export class DelegateNonConformance {
  static readonly type = '[Non Conformance] Delegate Non Conformance';
  constructor(public delegateNonConformance: IDelegateNonConformanceRequest) {}
}

export class CloseNonConformance {
  static readonly type = '[Non Conformance] Close Non Conformance';
  constructor(public idComment: IdComment) {}
}

export class ReopenNonConformance {
  static readonly type = '[Non Conformance] Reopen Non Conformance';
  constructor(public idComment: IdComment) {}
}

export class CompleteNonConformance {
  static readonly type = '[Non Conformance] Complete Non Conformance';
  constructor(public idComment: IdComment) {}
}

export class RejectNonConformance {
  static readonly type = '[Non Conformance] Reject Non Conformance';
  constructor(public idComment: IdComment) {}
}

export class RestoreNonConformance {
  static readonly type = '[Non Conformance] Restore Non Conformance';
  constructor(public idComment: IdComment) {}
}

export class LoadNonConformanceLogs {
  static readonly type = '[Non Conformance] Load Non Conformance Logs';
  constructor(public id: string) {}
}

export class PrintNonConformance {
  static readonly type = '[Non Conformance] Print Non Conformance';
  constructor(public printNonConformance: IPrintNonConformanceModel) {}
}

export class ClearCurrentNonConformance {
  static readonly type = '[Non Conformance] Clear Current Non Conformance';
}

export class SignCompletedNonConformance {
  static readonly type = '[Non Conformance] Sign Completed Non Conformance';
  constructor(public signNonConformance: ISignNonConformanceModel) {}
}

export class LoadNonConformanceStateCounts {
  static readonly type = '[Non Conformance] Load Non Conformance State Counts';
  constructor() {}
}

export class LoadReportsStatus {
  static readonly type = '[Non Conformance] Load Reports Status';
  constructor(
    public departmentIds?: string[],
    public from?: string,
    public to?: string
  ) {}
}

export class LoadOpenReportsStatus {
  static readonly type = '[Non Conformance] Load Open Reports Status';
  constructor(
    public severityIds?: string[],
    public departmentIds?: string[]
  ) {}
}

export class LoadOpenReportsForModal {
  static readonly type = '[Non Conformance] Load Open Reports For Modal';
  constructor(
    public filter: MainTableFilterModel,
    public relatedNonConformancesOnly: boolean
  ) {}
}

export class PrintNonConformanceReport {
  static readonly type = '[Non Conformance] Print Report';
  constructor(
    public filter?: PrintReportFilterModel,
    public menuId?: string,
    public status?: NonConformanceStatus
  ) {}
}

export class LoadNonConformanceSubtask {
  static readonly type = '[Non Conformance] Load Subtask';
  constructor(
    public ncId: string,
    public subtaskId: string
  ) {}
}

export class CreateNonConformanceSubtask {
  static readonly type = '[Non Conformance] Create Subtask';
  constructor(
    public ncId: string,
    public subtask: ISubtaskRequest
  ) {}
}

export class UpdateNonConformanceSubtask {
  static readonly type = '[Non Conformance] Update Subtask';
  constructor(
    public ncId: string,
    public subtaskId: string,
    public subtask: ISubtaskRequest
  ) {}
}

export class DeleteNonConformanceSubtask {
  static readonly type = '[Non Conformance] Delete Subtask';
  constructor(
    public ncId: string,
    public subtaskId: string
  ) {}
}

export class LoadNonConformanceSubtasksLogs {
  static readonly type = '[Non Conformance] Load Subtasks Logs';
  constructor(public ncId: string) {}
}

export class LoadNotificationRecipients {
  static readonly type = '[Non Conformance] Load Notification Recipients';
  constructor(
    public id: string,
    public actionType: NonConformanceActionType,
    public departmentId?: string
  ) {}
}
